import React from 'react';

const LoadingAnimation = ({ type = 'default' }) => {
  const renderContent = () => {
    switch (type) {
      case 'clubs':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-[1920px] mx-auto">
            {[...Array(6)].map((_, index) => (
              <div 
                key={index}
                className="bg-gray-900 backdrop-blur-sm rounded-xl shadow-xl overflow-hidden animate-pulse"
              >
                <div className="p-8 space-y-6">
                  <div className="flex items-center space-x-6">
                    <div className="w-20 h-20 flex-shrink-0 bg-gray-700 rounded-full"></div>
                    <div className="flex-grow">
                      <div className="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
                      <div className="space-y-2">
                        <div className="h-4 bg-gray-700 rounded w-1/2"></div>
                        <div className="h-4 bg-gray-700 rounded w-1/2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="h-16 bg-gray-700 rounded-lg"></div>
                </div>
              </div>
            ))}
          </div>
        );
      case 'players':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-[1920px] mx-auto">
            {[...Array(6)].map((_, index) => (
              <div 
                key={index}
                className="bg-gray-900 backdrop-blur-sm rounded-xl shadow-xl overflow-hidden animate-pulse"
              >
                <div className="p-8 space-y-6">
                  <div className="flex items-center space-x-6">
                    <div className="w-20 h-20 flex-shrink-0 bg-gray-700 rounded-full"></div>
                    <div className="flex-grow">
                      <div className="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
                      <div className="space-y-2">
                        <div className="h-4 bg-gray-700 rounded w-1/2"></div>
                        <div className="h-4 bg-gray-700 rounded w-1/2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="h-16 bg-gray-700 rounded-lg"></div>
                </div>
              </div>
            ))}
          </div>
        );
      case 'club-banner':
        return (
          <div className="bg-gray-900 rounded-2xl shadow-2xl overflow-hidden mb-12 mt-20 animate-pulse">
            <div className="p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
              <div className="w-32 h-32 md:w-48 md:h-48 flex-shrink-0 bg-gray-700 rounded-full"></div>
              <div className="flex-grow text-center md:text-left">
                <div className="h-12 bg-gray-700 rounded w-3/4 mx-auto md:mx-0 mb-4"></div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="h-6 bg-gray-700 rounded w-1/2"></div>
                  <div className="h-6 bg-gray-700 rounded w-1/2"></div>
                  <div className="h-6 bg-gray-700 rounded w-1/2"></div>
                </div>
              </div>
            </div>
          </div>
        );
      case 'search':
        return (
          <div className="mb-8">
            <div className="max-w-md mx-auto">
              <div className="h-12 bg-gray-800 rounded-lg animate-pulse"></div>
            </div>
          </div>
        );
      default:
        return (
          <div className="fixed inset-0 flex items-center justify-center">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-8 h-8 border-4 border-gray-700 border-t-transparent rounded-full animate-spin"></div>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 relative">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{ 
          backgroundImage: "url('https://t4.ftcdn.net/jpg/06/19/39/53/360_F_619395337_xfoBmAMfDhh0Wg5NRwVUUsZxJrUq8xBn.jpg')",
          zIndex: 0 
        }}
      />
      
      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-4 py-8 min-h-screen">
        {renderContent()}
      </div>
    </div>
  );
};

export default LoadingAnimation; 